import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/search.svg'


const _hoisted_1 = { class: "apInputSearch" }
const _hoisted_2 = { class: "apInputSearch__inner" }
const _hoisted_3 = { class: "apInputSearch__field" }
const _hoisted_4 = ["value", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "search",
            class: "apInputSearch__img"
          })
        ], -1)),
        _createElementVNode("input", {
          class: "apInputSearch__input",
          value: _ctx.modelValue,
          placeholder: _ctx.placeholder
        }, null, 8, _hoisted_4)
      ])
    ])
  ]))
}